module.exports = __webpack_public_path__ + "static/img/8.d03eeb32.png";